import React from 'react'
import parse from 'html-react-parser'
import DOMPurify from 'dompurify'
import type {ITemplate} from '../types'

export const getHighlightedText = ({
  keyword,
  input,
}: {
  keyword: string
  input: string
}): React.ReactNode => {
  if (keyword?.trim()) {
    const searched = keyword.trim()
    const regex = new RegExp(
      `(<)(script[^>]*>[^<]*(?:<(?!\\/script>)[^<]*)*<\\/script>|\\/?\\b[^<>]+>|!(?:--\\s*(?:(?:\\[if\\s*!IE]>\\s*-->)?[^-]*(?:-(?!->)-*[^-]*)*)--|\\[CDATA[^\\]]*(?:](?!]>)[^\\]]*)*]])>)|(${searched})`,
      'gi',
    )

    const highlighted = input.replace(regex, (match, p1, p2, p3) => {
      return p3 ? `<mark>${p3}</mark>` : match
    })

    return parse(DOMPurify.sanitize(highlighted))
  }

  return parse(DOMPurify.sanitize(input))
}

export const initiativeSortYear = (
  initiatives: ITemplate[],
  _goal: string,
): ITemplate[][] => {
  const sorted = [...initiatives].sort((a, b) =>
    (a.goal ?? '') < (b.goal ?? '')
      ? -1
      : (a.goal ?? '') > (b.goal ?? '')
        ? 1
        : 0,
  )

  let currentGroup = [sorted[0]]
  const groups: ITemplate[][] = []
  const unclassified: ITemplate[] = []

  for (let i = 1; i < sorted.length; i++) {
    if (sorted[i].goal === 'Unclassified') {
      unclassified.push(sorted[i])
    } else if (sorted[i].goal === currentGroup[0].goal) {
      currentGroup.push(sorted[i])
    } else {
      groups.push(currentGroup)
      currentGroup = [sorted[i]]
    }
  }

  return [...groups, currentGroup, unclassified]
}

export const initiativeUtil = {
  getHighlightedText,
  initiativeSortYear,
} as const
